import {
  Attribute,
  ChangeDetectorRef,
  Component, Inject,
  Injector,
  Optional
} from '@angular/core';
import {CommonModule, DatePipe} from "@angular/common";

import { DISPLAY_TYPE, IWidgetConfig , provideAsWidgetRef, Parent, register, styler } from "@wm/components-base";
import {BaseDateTimeComponent} from "../base-date-time.component";
import {getDateObj, getFormattedDate, getNativeDateObject, runtimeEventManager} from "@wm/core";
import moment from "moment";
import {App} from "@wm/core";
import { debounce, isString } from "lodash-es";
import {EVENT_MANAGER_PLUGINS} from "@angular/platform-browser";
import { getAppDefault } from '../utils/appDefaults';

const CURRENT_DATE = 'CURRENT_DATE';
const DEFAULT_CLS = 'app-datetime input-group';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-datetime',
  hostClass: DEFAULT_CLS,
  displayType: DISPLAY_TYPE.INLINE_BLOCK
};

@Component({
  selector: '[wmDateTime]',
  template: ` <input class="form-control app-textbox display-input"
                     [attr.aria-label]="hint || 'Date and time field'"
                     [name]="name"
                     type="{{loadNativeDateInput ? 'datetime-local' : 'text'}}"
                     [value]="displayValue"
                     [disabled]="disabled || readonly "
                     [required]="required"
                     [readOnly]="isReadOnly">

  <span class="input-group-btn" *ngIf="!loadNativeDateInput">
            <button type="button"
                    class="btn btn-default btn-date"
                    [tabindex]="tabindex"
                    [disabled]="disabled || readonly || isCurrentDate">
                <i aria-hidden="true"
                   class="app-icon wm-sl-l sl-calendar"></i>
            </button>
            <button type="button"
                    class="btn btn-default btn-time"
                    [tabindex]="tabindex"
                    [disabled]="disabled || readonly || isCurrentDate">
                <i aria-hidden="true"
                   class="app-icon wm-sl-l sl-time"></i>
            </button>
        </span>
  `,
  providers: [
    provideAsWidgetRef(DateTimeComponent),DatePipe
  ],
  exportAs: 'wmDateTime',
  standalone: true,
  imports: [ CommonModule ],
  styles: []
})
export class DateTimeComponent extends BaseDateTimeComponent {
  static initializeProps = register('wm-datetime');
  public bsDateValue: any;
  public hint: string;
  public showdropdownon: string;
  public isDateOpen = false;
  public isCurrentDate = false;
  private bsTimeValue: any;
  private proxyModel: any;
  private app: App;
  private timeinterval: any;
  private keyEventPlugin;
  private dateContainerCls: string;
  private _debouncedOnChange: Function = debounce(this.invokeOnChange, 10);

  constructor(inj: Injector,
              @Optional() viewParent: Parent,
              @Attribute('datepattern') public _datepattern: string,
              @Inject(EVENT_MANAGER_PLUGINS) evtMngrPlugins: any) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
    this.keyEventPlugin = evtMngrPlugins[1];
    this.dateContainerCls = `app-date-${this.widgetId}`;
    this._dateOptions.containerClass = `app-date-${this.dateContainerCls}`;
    this._dateOptions.showWeekNumbers = false;
  }

  override setAppDefaultForProp() {
    if (this._datepattern) {
      return;
    }
    let datepattern = getAppDefault('dateTimeFormat');
    if (!datepattern) {
      runtimeEventManager.on('wms:app-defaults-ready').subscribe(() => {
        this.datepattern = getAppDefault('dateTimeFormat');
        this.updateFormat('datetimepattern');
      });
      return;
    }
    this.datepattern = datepattern;
    this.updateFormat('datetimepattern');
  }

  get timestamp() {
    return this.proxyModel ? this.proxyModel.valueOf() : undefined;
  }

  get dateInputFormat() {

    return this._dateOptions.dateInputFormat || 'yyyy-MM-ddTHH:mm:ss';
  }

  get displayValue(): any {
    return getFormattedDate(this.datePipe, this.proxyModel, this.dateInputFormat) || '';
  }

  get nativeDisplayValue() {
    return getFormattedDate(this.datePipe, this.proxyModel, 'yyyy-MM-ddTHH:mm:ss') || '';
  }
  public onModelUpdate(newVal: any, type?: any) {
    if (type === 'date') {
      this.invalidDateTimeFormat = false;
      if (getFormattedDate(this.datePipe, newVal, this.dateInputFormat) === this.displayValue) {
        $(this.nativeElement).find('.display-input').val(this.displayValue);
      }
    }
    this.proxyModel = newVal;
    if (this.proxyModel) {
      this.bsDateValue = this.bsTimeValue = this.proxyModel;
    }
  }

  protected override onPropertyChange(key: string, nv: any, ov?: any) {
    if (key === 'datepattern') {
      this.updateFormat('datetimepattern');
    } else if (key === 'datavalue') {
      if (isString(nv) && nv.startsWith('bind:')) {
        return;
      }
      if (nv === CURRENT_DATE) {
        this.isCurrentDate = true;
        this.setTimeInterval();
      } else {
        this.proxyModel = nv ? getDateObj(nv, {isNativePicker: this.loadNativeDateInput}) : undefined;
        this.clearTimeInterval();
        this.isCurrentDate = false;
      }
      this.bsTimeValue = this.bsDateValue = this.proxyModel;
    } else {
      super.onPropertyChange(key, nv, ov);
    }
  }

  private setTimeInterval() {
    if (this.timeinterval) {
      return;
    }
    this.timeinterval = setInterval(() => {
      const currentTime = new Date();
      this.onModelUpdate(currentTime);
    }, 1000);
  }

  private clearTimeInterval() {
    if (this.timeinterval) {
      clearInterval(this.timeinterval);
      this.timeinterval = null;
    }
  }


}

